import { OwnProps } from '~/types/ownProps';

function meetsDataDependencies(props: OwnProps) {
  const {
    application: { vehicles },
  } = props;

  return vehicles.length > 0;
}

const step = {
  route: '/homeowners-insurance/quotes/auto-coverages',
  isAccessible: ({ application }: OwnProps) => application.bundled || application.isAutoOnly,
  breadcrumbStep: 'auto',
  meetsDataDependencies,
};

export default step;
